import pageStyles from 'assets/styles/components/Page.styles';
import Container from 'components/Container/Container';
import Loader from 'components/Loader/Loader';
import Redirecting from 'components/Redirecting/Redirecting';
import { useSessionContext } from 'context/SessionProvider/SessionProvider';
import TechnicalProvidersTable from 'features/programmatic/technicalProvider/components/TechnicalProvidersTable/TechnicalProvidersTable';
import { History } from 'history';
import {
  PermissionName,
  TechnicalProviderLegacy,
  useAllTechnicalProvidersLegacyQuery,
} from 'interfaces/generated.types';
import React from 'react';
import { userHasAtLeastOnePermission } from 'utils/permissions';

interface ITechnicalProvidersPageProps {
  history: History;
  userPermissions: PermissionName[];
}

const editPermissions = [PermissionName.Primary, PermissionName.Programmatic];

const TechnicalProvidersPage = ({
  history,
  userPermissions,
}: ITechnicalProvidersPageProps) => {
  const {
    state: {
      user: { activeTerritory },
    },
  } = useSessionContext();

  const { loading, data, error } = useAllTechnicalProvidersLegacyQuery({
    errorPolicy: 'all',
    variables: { territories: [activeTerritory!] },
  });
  const classes = pageStyles();

  if (!loading && error && !(data && data.allTechnicalProvidersLegacy))
    return <Redirecting history={history} />;

  const hasEditPermissions = userHasAtLeastOnePermission(
    userPermissions,
    editPermissions
  );
  return (
    <main className={classes.page}>
      <Container>
        <h1 className="sr-only">Programmatic Connectors</h1>
        <div className={classes.table}>
          {loading ? (
            <Loader />
          ) : (
            <TechnicalProvidersTable
              allTechnicalProviders={
                data?.allTechnicalProvidersLegacy as TechnicalProviderLegacy[]
              }
              isEditable={hasEditPermissions}
              history={history}
              activeTerritory={activeTerritory!}
            />
          )}
        </div>
      </Container>
    </main>
  );
};

export default TechnicalProvidersPage;
